import React from "react";
import { useSelector } from "react-redux";
import { Box, useTheme } from "@mui/material";

const Ask = React.memo(({ symbolId = 7, digits }) => {
  const symbol = useSelector((state) => state.updateSymbol.symbols?.[symbolId]);
  const theme = useTheme();

  const getColor = () => {
    if (symbol?.askColor === 'up') return '#079a80';     // green
    if (symbol?.askColor === 'down') return '#da5244';   // red
    return theme.palette.text.secondary;                 // fallback
  };

  const convertAmount = () => {
    const ask = symbol?.ask?.toFixed(digits || symbol?.digits)?.toString() || '0.00';
    const [intPart, decimals = ''] = ask.split('.');

    const textColor = getColor();

    if (decimals.length > 2) {
      const lastThree = decimals.slice(-3);
      const rest = decimals.slice(0, -3);
      const bigPart = lastThree.slice(0, 2);
      const superPart = lastThree.slice(2);
      return (
        <Box sx={{ display: "flex", alignItems: 'end', justifyContent: "end", minWidth: "60px", color: textColor }}>
          <div style={{ fontSize: 15, fontWeight: 600 }}>{intPart}.{rest}</div>
          <div style={{ fontSize: 22, fontWeight: 600, lineHeight: 1.3 }}>{bigPart}</div>
          <div style={{ fontSize: 15, fontWeight: 600, alignSelf: "start" }}>{superPart}</div>
        </Box>
      );
    } else {
      const padded = decimals.padEnd(2, '0');
      const bigPart = padded.slice(-2);
      const rest = padded.length > 2 ? padded.slice(0, -2) : '';
      return (
        <Box sx={{ display: "flex", alignItems: 'end', justifyContent: "end", minWidth: "60px", color: textColor }}>
          <div style={{ fontSize: 15, fontWeight: 600 }}>{intPart}.{rest}</div>
          <div style={{ fontSize: 22, fontWeight: 600, lineHeight: 1.3 }}>{bigPart}</div>
        </Box>
      );
    }
  };

  return convertAmount();
});

export default Ask;